module.exports = __webpack_public_path__ + "static/media/slideshow-5.4c564256.jpg";